export const getFuneralProvisionQuestionnaire = (questionnaire, i18nTFunc) => {
  const t = (content) => i18nTFunc(`${questionnaire}:${content}`);
  return [
    {
      title: t('s_start_title'),
      content: t('s_start_content'),
    },
    {
      title: t('s_1_title'),
      content: t('s_1_content'),
    },
    {
      title: t('s_2_title'),
      content: t('s_2_content'),
    },
    {
      title: t('s_3_title'),
      content: t('s_3_content'),
    },
    {
      title: t('s_end_title'),
      content: t('s_end_content'),
    },
  ];
};
